<template>
  <div class="middle">
    <div class="content">
      <div class="left-title">
        直播总场数 <br /><span class="totalTips">累计</span>
      </div>
      <div class="value-box">
        <div class="value" v-for="(item, index) in broadcastTotal" :key="index">
          <countTo :startVal="0" :endVal="Number(item)" :duration="1500" />
        </div>
      </div>
      <div class="unit">次</div>
    </div>
    <div class="content">
      <div class="left-title">
        观看人数<br /><span class="totalTips">累计</span>
      </div>
      <div class="value-box">
        <div class="value" v-for="(item, index) in viewersTotal" :key="index">
          <countTo :startVal="0" :endVal="Number(item)" :duration="1500" />
        </div>
      </div>
      <div class="unit">个</div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
export default {
  name: 'Middle',
  components: { countTo },
  data() {
    return {
      viewersNum: 92349,
      broadcastsNum: 51
    }
  },
  computed: {
    viewersTotal() {
      return this.viewersNum.toString().split('')
    },
    broadcastTotal() {
      return this.broadcastsNum.toString().split('')
    }
  }
}
</script>

<style lang="scss" scoped>
.middle {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(255, 255, 255, 100);
    width: 100%;
    .left-title {
      width: 0.9rem;
      font-size: 0.18rem;
      text-align: left;
      margin-top: 0.2rem;
      .totalTips {
        font-size: 0.16rem;
        opacity: 0.45;
      }
    }
    .value-box {
      width: 50%;
      display: flex;
      justify-content: end;
    }
    .value {
      font-size: 0.32rem;
      margin-right: 0.05rem;
      padding: 10px;
      background: url('~@assets/cockpit/counter.png') no-repeat center/100% auto;
    }
    .unit {
      font-size: 0.16rem;
    }
  }
}
</style>
